export const REPORTS_TABS = {
  TRANSACTIONS_BY_TYPE_CHART: 0,
  TRANSACTIONS_BY_CATEGORY_CHART: 1,
  TRANSACTIONS_BY_PAYMENT_METHOD_CHART: 2,
  TRANSACTIONS_PER_MONTH_CHART: 3,
  TRANSACTIONS_PER_CLIENT_PROVIDER_CHART: 4,
  TRANSACTIONS_LAST_SEVEN_DAYS: 5,
  TRANSACTIONS_BY_STATUS: 6,
  TRANSACTIONS_BY_HOUR: 7,
};

export const TRANSACTIONS_TABS = {
  ACTIVE_TRANSACTIONS: 0,
  ARCHIVED_TRANSACTIONS: 1,
  TRANSACTIONS_ATTACHMENTS: 2,
};

export const FREQUENT_TRANSACTIONS_TABS = {
  ACTIVE_TRANSACTIONS: 0,
  ARCHIVED_TRANSACTIONS: 1,
};

export const NOTIFICATIONS_TABS = {
  RECURRING_TRANSACTIONS: 0,
  PENDING_TRANSACTIONS: 1,
  MY_NETWORK: 2,
  SHARED_TRANSACTIONS: 3,
};
